import { useOrganization } from "@/api/services/admin/organization";
import { useEnum } from "@/api/services/global/enum";
import { ItemInfo } from "@/components/commons/ItemInfo";
import { InnerBox } from "@/modules/irohana-components/elements/InnerBox";
import { EMPTY_STR } from "@/constants/string";
import { findLabelByValue } from "@/utils/object";
import { Grid } from "@mui/material";

export const OrganizationContractInfo = () => {
  const { data } = useOrganization();
  const { data: statusOptions } = useEnum("EOrganizationContractStatus");
  const org = data?.data;

  const contractStatus = org?.contractStatus ? findLabelByValue(statusOptions, org.contractStatus) || EMPTY_STR.TEXT : EMPTY_STR.TEXT;

  return (
    <InnerBox title="契約情報" p={3} bordered>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <ItemInfo label="ステータス" value={contractStatus} />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo label="契約プラン" value={org?.contractPlan} />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo label="トライアル開始日" value={org?.trialStartDate} type="date" />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo label="トライアル終了日" value={org?.trialEndDate} type="date" />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo label="契約日" value={org?.contractStartDate} type="date" />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo label="解約日" value={org?.contractEndDate} type="date" />
        </Grid>
      </Grid>
    </InnerBox>
  );
};
